import React, { Component } from "react";
import {randomHex, toInt} from '../../Utils'
import moment from 'moment';
import { withStyles, Grid, Fade, CircularProgress, Typography, Tabs, Tab, Table, TableHead, TableRow, TableCell, TableBody } from "@material-ui/core";
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import Paper from '@material-ui/core/Paper';
import { Color } from "../../Constants";
import { ReportService } from "../../Services/ReportService";
import { Doughnut } from "react-chartjs-2";
import ReturnsSection from "../../components/ReturnsSection";
import CustomDialog from "../../components/CustomDialog";

const styles = theme =>({
    fab: {
        margin: theme.spacing(1),
    },
    root: {
      width: '100%',
      marginTop: theme.spacing(3),
    },
    tablecell: {
        fontSize: '40pt'
    },
    paper: {
        position: 'absolute',
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing(4),
        width: "80%",
        outline: 'none',
        textAlign: 'center',
        color: theme.palette.text.secondary,
        marginBottom : '20px',
    },
    formControl: {
        margin: theme.spacing(1),
        marginTop: theme.spacing(3),
        minWidth: 200,
        marginLeft: theme.spacing(2),
        [theme.breakpoints.up('md')]: {
            marginLeft: theme.spacing(1),
        },
    },
    section: {
		width: '100%',
        minHeight: 400,
        [theme.breakpoints.down('md')]: {
			minHeight: 0,
		},
		overflow: 'auto',
		overflowX: 'auto',
		paddingTop : theme.spacing(1), 
		paddingLeft: theme.spacing(1), 
		paddingRight: theme.spacing(1),
		paddingBottom: theme.spacing(1)
    },
    table: {
        height: 300,
        [theme.breakpoints.down('md')]: {
            minHeight: 0,
            height: '100%'
		},
        overflow: 'auto'
    }
  });

class ReturnsReport extends Component {

    constructor(props) {
      super(props);
      this.state = {
        productWise: [],
        routeWise: [],
        route_product: [],
        product_route: [],
        startDate: moment().subtract(7, "days"),
        endDate: moment(),
        showSpinner: false,
        route_pie_data: {},
        product_pie_data: {},
        product_tab_value: 0,
        product_route_tab_value: undefined,
        route_product_tab_value: undefined,
        product_rows: [],
        product_route_rows: [],
        route_product_rows: [],
        store_rows: [],
        store_data: [],
        dialog : {
            children: [],
            title : undefined, 
            open : false
        }
      }
    }

    componentDidMount(){
        this.setState({showSpinner: true}, () => this.fetchData());
        this.props.setTitle('Store Returns Pattern');
    }

    handleClose = () => {
		this.setState({dialog :{open: false, children: [], title: undefined}});
    }
    
    openDialog = (element) => event => {
		if(event){
			event.preventDefault();
		}

        let children = [], rows = [];

        let returns = this.state.store_data.filter(s => s.user_id === element.user_id);
        returns.sort((a, b) => (a.count < b.count) ? 1 : -1);

		returns.forEach((element, index) => {
            rows.push(
                        <TableRow key={index} >
                            <TableCell>{element.product_name}</TableCell>
                            <TableCell>{element.count}</TableCell>
                        </TableRow>
                );
        });

        children.push(<Table key="table">
            <TableHead>
                <TableRow>
                    <TableCell>Product</TableCell>
                    <TableCell>Returned Qty</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {rows}
            </TableBody>
        </Table>);


		this.setState({dialog :{open: true, children, title: returns[0].store_name}});
    }
    
    openDialogStoreList = (product_name, route_id) => event => {
		if(event){
			event.preventDefault();
        }
        let { store_data } = this.state;

        let store_list = store_data.filter(s => s.route_id === route_id && s.product_name === product_name);

        let children = [], rows = [];

        store_list.sort((a, b) => (a.count < b.count) ? 1 : -1);

		store_list.forEach((element, index) => {
            rows.push(
                        <TableRow key={index} >
                            <TableCell>{element.store_name}</TableCell>
                            <TableCell>{element.count}</TableCell>
                        </TableRow>
                );
        });

        children.push(<Table key="table">
            <TableHead>
                <TableRow>
                    <TableCell>Store</TableCell>
                    <TableCell>Returned Qty</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {rows}
            </TableBody>
        </Table>);


		this.setState({dialog :{open: true, children, title: `${product_name} - ${route_id}`}});
	}

    fetchStoreData = () => {
        let {startDate, endDate} = this.state;
        let store_rows = [];
        ReportService.reportReturnsByStore(startDate, endDate)
        .then((data) => {
            console.log(data);
            if(data.report.length > 0){
                let storeWise = [];
                const stores = new Set(data.report.map(s => s.user_id));
                stores.forEach((store) => {
                    let qty = data.report.filter(s => s.user_id === store).reduce((accumulator, currentValue) => accumulator + toInt(currentValue.count), 0);
                    storeWise.push({user_id: store, store_name: data.report.filter(f => f.user_id === store)[0].store_name, returned_qty: qty});
                });
                // store_rows
                storeWise.sort((a, b) => (a.returned_qty < b.returned_qty) ? 1 : -1);
                storeWise.forEach((element, index) => {
                    store_rows.push(
                        <TableRow key={index} style={{cursor: "pointer"}} onClick={this.openDialog(element)}>
                            <TableCell>{element.store_name}</TableCell>
                            <TableCell>{element.returned_qty}</TableCell>
                        </TableRow>
                    );
                });
            }

            this.setState({store_rows, store_data: data.report})
        })
        .catch((error) => {
            console.log(error);
        })
    }


    fetchData = () => {
        let {startDate, endDate} = this.state;
        this.fetchStoreData();
        let productWise = [], routeWise = [], route_product = new Map(), product_route = new Map();
        let product_route_tab_value, route_product_tab_value;
        let route_pie_data = {}, product_pie_data = {};
        let product_rows = [];
        ReportService.reportReturnsByRoute(startDate, endDate)
        .then((data) => {
             if(data.report.length > 0){
                const routes = new Set(data.report.map(r => r.route_id));
                const products = new Set(data.report.map(r => r.product_name));
                routes.forEach(route => {
                        let qty = data.report.filter(r => r.route_id === route).reduce((accumulator, currentValue) => accumulator + toInt(currentValue.count), 0);
                        routeWise.push({route_id: route, returned_qty: qty});
                        route_product.set(route, data.report.filter(r => r.route_id === route).map(r => ({product_name : r.product_name, returned_qty: toInt(r.count)})));
                });
                products.forEach(product => {
                    let qty = data.report.filter(r => r.product_name === product).reduce((accumulator, currentValue) => accumulator + toInt(currentValue.count), 0);
                    productWise.push({product_name: product, returned_qty: qty});
                    product_route.set(product, data.report.filter(r => r.product_name === product).map(r => ({route_id : r.route_id, returned_qty: toInt(r.count)})));
                });

                // Route Pie
                let labels = [], count = [], backgroundColor = [];
                routeWise.forEach(element => {
                    labels.push(element.route_id);
                    count.push(element.returned_qty);
                    backgroundColor.push(randomHex());
                });
                route_pie_data = {
                    labels: labels,
                    datasets: [{
                        label: "Route wise",
                        data: count,
                        backgroundColor: backgroundColor
                    }]
                };

                // Product Pie
                labels = [];
                count = [];
                backgroundColor = [];
                productWise.forEach(element => {
                    labels.push(element.product_name);
                    count.push(element.returned_qty);
                    backgroundColor.push(randomHex());
                });
                product_pie_data = {
                    labels: labels,
                    datasets: [{
                        label: "Product wise",
                        data: count,
                        backgroundColor: backgroundColor
                    }]
                };
                
                productWise.sort((a, b) => (a.returned_qty < b.returned_qty) ? 1 : -1);
                productWise.forEach((element, index) => {
                    product_rows.push(
                        <TableRow key={index}>
                            <TableCell>{element.product_name}</TableCell>
                            <TableCell>{element.returned_qty}</TableCell>
                        </TableRow>
                    );
                });

                product_route_tab_value = product_route.keys().next().value;
                route_product_tab_value = route_product.keys().next().value;

                
            }
            this.setState({routeWise, productWise, route_product, product_route, route_pie_data, product_pie_data, product_rows, product_route_tab_value, route_product_tab_value, showSpinner: false}, () => {
                if(product_route_tab_value && route_product_tab_value){
                    this.updateRouteProductRows(route_product_tab_value);
                    this.updateProductRouteRows(product_route_tab_value);
                } else {
                    this.setState({route_product_rows: [], product_route_rows: []});
                }
            });
        })
        .catch((error) => {
            console.log(error);
            this.setState({showSpinner: false});
        })
    }

    handleChangeStartDate = (date) => {
        this.setState({
            startDate: date,
        }, () => this.fetchData(0, this.state.numItemsPerPage));
    }

    handleChangeEndDate = (date) => {
        this.setState({
            endDate: date,
        }, () => this.fetchData(0, this.state.numItemsPerPage));
    }

    handleChangeProduct= (event, index) => {
        this.setState({product_tab_value : index});
    }

    handleChangeProductRoute = (event, index) => {
        this.setState({product_route_tab_value : index});
        this.updateProductRouteRows(index);
    }

    updateProductRouteRows = (index) => {
        let product_route_rows = [];
        let {product_route} = this.state;
        product_route.get(index).sort((a, b) => (a.returned_qty < b.returned_qty) ? 1 : -1);
        product_route.get(index).forEach((element, i) => {
            product_route_rows.push(
                <TableRow key={i} style={{cursor: "pointer"}} onClick={this.openDialogStoreList(index, element.route_id)}>
                    <TableCell>{element.route_id}</TableCell>
                    <TableCell>{element.returned_qty}</TableCell>
                </TableRow>
            );
        });
        this.setState({product_route_rows});
    }

    handleChangeRouteProduct = (event, index) => {
        this.setState({route_product_tab_value : index});
        this.updateRouteProductRows(index);
    }

    updateRouteProductRows = (index) => {
        let route_product_rows = [];
        let {route_product} = this.state;
        route_product.get(index).sort((a, b) => (a.returned_qty < b.returned_qty) ? 1 : -1);
        route_product.get(index).forEach((element, i) => {
            route_product_rows.push(
                <TableRow key={i} style={{cursor: "pointer"}} onClick={this.openDialogStoreList(element.product_name, index)}>
                    <TableCell>{element.product_name}</TableCell>
                    <TableCell>{element.returned_qty}</TableCell>
                </TableRow>
            );
        });
        this.setState({route_product_rows});
    }
    
    render() {
        let { dialog, store_rows, startDate, endDate, message, showSpinner, route_pie_data, product_pie_data, product_tab_value, product_rows, product_route, product_route_rows, product_route_tab_value, route_product, route_product_rows, route_product_tab_value} = this.state;
        const { classes } = this.props;
        let tabs = [];
        product_route.forEach((value, key, map) => (tabs.push(<Tab label={key} value={key} key={key} />)));
        let tabsRoute = [];
        route_product.forEach((value, key, map) => (tabsRoute.push(<Tab label={key} value={key} key={key} />)));
        return ( 
            <div className="Home" style={{marginTop: 32}}>
                <Paper style={{paddingTop: 8, paddingBottom: 8}}>
                    <div align="left">
                        <MuiPickersUtilsProvider utils={MomentUtils}>
                        <DatePicker
                            variant="dialog"
                            margin="normal"
                            label="From"
                            value={startDate}
                            onChange={this.handleChangeStartDate}
                            format='DD MMM YYYY'
                            maxDate={endDate}
                            inputVariant="outlined"
                            className={classes.formControl}
                            style={{ height: "100%", marginTop: "24px"}}
                        />
                        <DatePicker
                            variant="dialog"
                            margin="normal"
                            label="To"
                            value={endDate}
                            minDate={startDate}
                            onChange={this.handleChangeEndDate}
                            format='DD MMM YYYY'
                            inputVariant="outlined"
                            className={classes.formControl}
                            style={{ height: "100%", marginTop: "24px"}}
                        />
                        </MuiPickersUtilsProvider>
                    </div>
                </Paper>
                { message &&
                    <div style={{backgroundColor: 'white', color:"red", paddingTop:50}}>{message}</div>
                }
                <Grid container spacing={2} style={{marginTop: 20}}>
                    <Grid item lg={12} xs={12}>
                        <ReturnsSection showProgress={true} startdate={startDate} enddate={endDate} sectionStyle={classes.section}/>
                    </Grid>
                    <Grid item lg={6} xs={12}>
                        <Paper className={classes.section}>
                            <Typography variant="body2" component="h4" align="center">
                                Route with maximum returns 
                            </Typography>
                            <Doughnut options={{responsive : true, maintainAspectRatio: true, onClick: null}} data={route_pie_data} legend={{position :"bottom"}}/>
                        </Paper>
                    </Grid>
                    <Grid item lg={6} xs={12}>
                        <Paper className={classes.section}>
                            <Typography variant="body2" component="h4" align="center">
                                Product with maximum returns 
                            </Typography>
                            <Tabs value={product_tab_value} onChange={this.handleChangeProduct} aria-label="simple tabs example">
                                <Tab label="Graphical"  />
                                <Tab label="Tabular" />
                            </Tabs>
                            { 
                                product_tab_value === 0 &&
                                <Doughnut options={{responsive : true, maintainAspectRatio: true, onClick: null}} data={product_pie_data} legend={{position :"bottom"}}/>
                            }
                            { 
                                product_tab_value === 1 &&
                                <div className={classes.table}>
                                    <Table stickyHeader>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Product</TableCell>
                                                <TableCell>Returned Qty</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {product_rows}
                                        </TableBody>
                                    </Table>
                                </div>
                            }
                        </Paper>
                    </Grid>
                    <Grid item lg={6} xs={12}>
                        <Paper className={classes.section}>
                            <Typography variant="body2" component="h4" align="center">
                                Product wise route returns 
                            </Typography>
                            <Tabs variant="scrollable" scrollButtons="auto" value={product_route_tab_value} onChange={this.handleChangeProductRoute} aria-label="product route tabs">
                                {tabs}
                            </Tabs>
                            <div className={classes.table}>
                                <Table stickyHeader>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Route</TableCell>
                                            <TableCell>Returned Qty</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {product_route_rows}
                                    </TableBody>
                                </Table>
                            </div>
                        </Paper>
                    </Grid>
                    <Grid item lg={6} xs={12}>
                        <Paper className={classes.section}>
                            <Typography variant="body2" component="h4" align="center">
                                Route wise product returns 
                            </Typography>
                            <Tabs variant="scrollable" scrollButtons="auto" value={route_product_tab_value} onChange={this.handleChangeRouteProduct} aria-label="route product tabs">
                                {tabsRoute}
                            </Tabs>
                            <div className={classes.table}>
                                <Table stickyHeader>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Product</TableCell>
                                            <TableCell>Returned Qty</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {route_product_rows}
                                    </TableBody>
                                </Table>
                            </div>
                        </Paper>
                    </Grid>
                    <Grid item lg={6} xs={12}>
                        <Paper className={classes.section}>
                            <Typography variant="body2" component="h4" align="center">
                                Storewise Returns
                            </Typography>
                            <div className={classes.table}>
                                <Table stickyHeader>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Store</TableCell>
                                            <TableCell>Total Returned Qty</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {store_rows}
                                    </TableBody>
                                </Table>
                            </div>
                        </Paper>
                    </Grid>
                </Grid>
                <Fade
                  key="spinner"
                  in={showSpinner}
                  style={{
                    transitionDelay: showSpinner ? '10ms' : '0ms',
                    position: 'absolute', left: '50%', top: '50%'
                  }}
                  unmountOnExit
                  >
                  <CircularProgress style={{marginTop: 20, color: Color.green}} color="inherit" size={60}/>
                </Fade>
                <CustomDialog fullWidth maxWidth={"md"} title={dialog.title} buttonText={"CLOSE"} handleClose={this.handleClose} open={dialog.open}>
					{dialog.children}
				</CustomDialog>
            </div>
        );
    }
}

export default withStyles(styles)(ReturnsReport);